import { DialogContent } from '../../../goods-view/components/Styles';
import { DialogActions } from '@mui/material';
import DialogView from '../../../../components/dialog-view/DialogView';
import Button from '../../../../components/button/Button';
import styled from 'styled-components';
import TextField from '../../../../components/text-field/TextField';
import { useState } from 'react';
import AddressAutocomplete from '../../../../components/address-autocomplete/AddressAutocomplete';
import { ContactInfo, ContactPersonTypeEnum, LocationDTO } from '../../../../api/api';
import MeterService from '../../../../services/MeterService';
import NotificationService from '../../../../services/NotificationService';
import { log } from '../../../../utils/logging/log';
import Select, { MenuItem } from '../../../../components/select/Select';
import { getEnumDisplayValue } from '../../../../utils/enumUtils';

interface Props {
  handleClose: () => void;
  workTaskId?: number;
  addContactCallback: (newContact: ContactInfo) => void;
}

export default function AddContactPersonDialog(props: Props) {
  const { handleClose, workTaskId, addContactCallback } = props;
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [address, setAddress] = useState<LocationDTO>();
  const [otherInformation, setOtherInformation] = useState('');
  const [contactType, setContactType] = useState<ContactPersonTypeEnum>(ContactPersonTypeEnum.Installer);

  const handleSubmit = () => {
    if (!workTaskId) return;
    const body = {
      name,
      email,
      companyName,
      phoneNumber,
      otherInformation,
      contactType,
      address: {
        cityName: "",
        houseNumber: "",
        postalCode: parseInt('0000'),
        streetName: ""
      }
    } as ContactInfo;

    MeterService.addContact(workTaskId, body)
      .then(() => {
        NotificationService.success('Kontaktperson blev oprettet.');
        addContactCallback(body);
        handleClose();
      })
      .catch((e) => {
        log(e);
        NotificationService.error('Kontaktperson kunne ikke oprettes.');
      });
  };

  return (
    <DialogView open handleClose={handleClose}>
      <StyledDialogContent>
        <Row>
          <TextField label={'Navn'} value={name} onChange={(e) => setName(e.target.value)} />
          <TextField label={'Telefonnummer'} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
        </Row>
        <Row>
          <Select fullWidth value={contactType} onChange={(e) => setContactType(e.target.value as ContactPersonTypeEnum)}>
            {Object.values(ContactPersonTypeEnum).map((status) => (
              <MenuItem key={status} value={status}>
                {getEnumDisplayValue(status)}
              </MenuItem>
            ))}
          </Select>
        </Row>
        <Row>
          <TextField
            label={'Yderligere information (Detaljer)'}
            value={otherInformation}
            onChange={(e) => setOtherInformation(e.target.value)}
            fullWidth
          />
        </Row>
      </StyledDialogContent>
      <DialogActions>
        <Button variant="secondary" onClick={handleClose}>
          Annuller
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Opret
        </Button>
      </DialogActions>
    </DialogView>
  );
}

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 70vw;
  max-width: 700px;
`;
const Row = styled.div`
  display: flex;
  margin: 10px 20px;

  & > * {
    margin-right: 20px !important;
  }
`;
